import React from "react";

const ProfileHeaderChevronIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.889 12L9 8.111L10.111 7L15.111 12L10.111 17L9 15.889L12.889 12Z"
      fill="#596970"
    />
  </svg>
);

export default ProfileHeaderChevronIcon;
